// File: App.js
import React from "react";
import "./App.css";
import Home from "./components/home";

function App() {

  return (
    <div className="main">
      <Home />
    </div>
    
  );
}

export default App;
